import moment from 'moment';
import { roomService } from '../network/services/room.service';
import {ResponseError} from "../network/response/response-error";
import {DISABLE_ROOM_IF_ON_CART, IF_BAR_THEN_ONLY_BAR, ONLY_SAME_ZONE_BOOKABLE} from "../helpers/config";

export default {
  namespaced: true,
  state: {
    loading: false,
    roomGroupLabel: 'MiHotel',
    results: [],
    roomAvailable: '',
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload;
    },
    SET_ROOM_GROUP_LABEL(state, payload) {
      if (!payload) {
        state.roomGroupLabel = 'MiHotel';
        return;
      }
      state.roomGroupLabel = payload;
    },
    SET_ROOM_AVAILABLE (state, payload) {
      state.roomAvailable = payload;
    }
  },
  actions: {
    async fetch(context, data = {}) {
      context.commit('SET_LOADING', true);
      context.commit('SET_ROOM_AVAILABLE', "");
      const roomIds = data.roomIds || context.rootState.preFetchRoom.roomIds;
      const dates = context.rootState.preFetchRoom.dates;
      const nbGuest = context.rootState.preFetchRoom.nbGuest;
      const lang = context.rootState.lang.currentLang;
      const sameDate = context.rootState.preFetchRoom.input.sameDate
      const roomGroup = data.roomGroup || null;
      context.commit('SET_RESULTS', []);
      context.commit('SET_ROOM_GROUP_LABEL', null);
      const response = await roomService.fetchPreBookableInfos(roomIds, dates, nbGuest, roomGroup, lang, context.rootState.preFetchRoom.input, sameDate);
      const roomGroupName = response.get('RoomGroup.one.text.name');
      let rooms = response.get('Room.many', []);

      const currentShoppingCart = context.rootState.shoppingCart.shoppingCart.bookings;
      if (DISABLE_ROOM_IF_ON_CART) {
        for (const booking of currentShoppingCart) {
          const start = booking.start.slice(0,10);
          const end = booking.end.slice(0,10);
          for (const date of dates) {
            if (date >= start && dates < end) {
              rooms = rooms.filter(r => r.id !== booking.room.id)
            }
          }
        }
      }
      if (ONLY_SAME_ZONE_BOOKABLE) {
        let availableProvider = null;
        if (currentShoppingCart.length > 0) {
          availableProvider = currentShoppingCart[0].room.provider;
        }
        rooms = rooms.filter(r => r.provider === availableProvider || availableProvider === null);
      }
      if (IF_BAR_THEN_ONLY_BAR) {
        let barOnly = false;
        let nanrOnly = false;
        if (currentShoppingCart.length > 0) {
          for (const booking of currentShoppingCart) {
            if (booking.room_price_id !== 1) {
              barOnly = true;
            } else {
              nanrOnly = true;
            }
          }
        }
        if (barOnly) {
          // TODO implement from db
          rooms = rooms.map(room => {
            room.price_plans = room.price_plans.map(price_plan => {
              price_plan.input_prices = price_plan.input_prices.map(inputPrice => {
                inputPrice.edges = inputPrice.edges.filter(edge => {
                  return edge.from.id > 1
                })
                return inputPrice
              })
              return price_plan;
            })
            return room;
          })
        } else if (nanrOnly) {
          // TODO implement from db
          rooms = rooms.map(room => {
            room.price_plans = room.price_plans.map(price_plan => {
              price_plan.input_prices = price_plan.input_prices.map(inputPrice => {
                inputPrice.edges = inputPrice.edges.filter(edge => {
                  return edge.from.id === 1
                })
                return inputPrice
              })
              return price_plan;
            })
            return room;
          })
        }
      }

      if (!(roomGroupName instanceof ResponseError)) {
        context.commit('SET_ROOM_GROUP_LABEL', roomGroupName);
      } else {
        //TODO catch errors
      }
      if (!(rooms instanceof ResponseError)) {
        context.commit('mapWidget/SET_LOCATIONS', rooms.map(r => ({
          lat: r.position.lat,
          lng: r.position.lng,
          name: roomGroupName,
        })), { root: true });
        context.commit('SET_RESULTS', rooms);
      } else {
        //TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/booking-step2.store.js